import React from "react";
import { SessionInterface } from "../../../../store/mine_craft/sessionsSlice";
import Card from "../../../../componets/Card";

const _Details = ({ session }: { session: SessionInterface | undefined }) => {
  if (!session) {
    return null;
  }

  return (
    <Card className='v-mb-20' />
  );
}

export default _Details;
